
      import Search from './search.vue'
      import type { App, Plugin } from 'vue'

      export const SearchPlugin: Plugin = {
        install(app: App) {
          app.component('Search', Search)
        },
      }
      export { Search }
      